import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slice/authSlice";
import muteReducer from "./slice/muteSlice";
import scrollReducer from "./slice/scrollPositionSlice";
import profileReducer from "./slice/profileSlice";
import userReducer from "../features/auth/user.reducer";
import teacherReducer from "../features/teacher/teacherSlice";

export default configureStore({
  reducer: {
    auth: authReducer,
    mute: muteReducer,
    scrollPosition: scrollReducer,
    profile: profileReducer,
    user: userReducer,
    teacher: teacherReducer,
  },
});
